/**
 *
 * @module deepObject/get
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define('deepObject/get',['./util'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('./util'));
    } else {
        root.bamDeepObjectGet = factory(root.bamDeepUtil);
    }

}(this, function(deepUtil) {

    'use strict';

    return function(obj, prop) {

        // @todo not a regexp guru -- can this be reduced to one expression?
        var props = deepUtil.getProps( prop ),
            i = 0,
            n,
            ret;

        n = props.length;
        while(typeof(obj = obj[props[i]]) !== 'undefined' && ++i < n) {}
        ret = obj;

        return ret;

    };

}));

